import React from 'react'

export default function PaddingTopBottom({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'
    return (
        <svg
            className={className}
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path d='M7 6H13H7Z' fill={color} />
            <path d='M7 6H13' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
            <path d='M7 14H13' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
            <rect x='4' y='3' width='12' height='14' rx='2' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
        </svg>
    )
}
